<template>
    <div id="app">
        <v-app  id="inspire" style="background: #CFD8DC">
            <v-container>
                <v-layout>
                    <h4 class="subheading font-weight-medium">SETTINGS</h4>
                    <v-spacer></v-spacer>
                    <h4 class="subheading font-weight-medium">{{user.displayName}}</h4>
                </v-layout>

                <v-layout>
                    <v-flex xs12>
                    <v-tabs v-model="active" color="cyan" dark slider-color="yellow" fixed-tabs>
                        <v-tab v-for="(item,index) in items" :key="index" ripple>{{item}}</v-tab>
                        <v-tab-item v-for="(item,index) in items" :key="index">
                            <div>
                            <v-layout v-if="item=='HO-Users'" row wrap> 
                                <v-flex xs6>
                                    <v-container fluid grid-list-md>
                                        <v-layout>
                                            <v-flex xs12>
                                                <v-text-field v-model="email" label="Email" required></v-text-field>
                                                <v-spacer></v-spacer>
                                                <v-flex xs12 right>
                                                    <v-btn dark color="blue accent-4" @click="saveUser()">submit</v-btn>
                                                    <v-btn dark color="red accent-4" @click="clearUser()">clear</v-btn>
                                                </v-flex>
                                                <br><br>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-flex>

                                <v-flex xs6>
                                    <v-container fluid grid-list-md>
                                        <v-layout>
                                            <v-flex xs12>
                                                <v-data-table :headers="emailHeader" :items="emails" item-key="Id" class="elevation-1">
                                                    <template v-slot:items="props">
                                                        <td>{{ props.item.email }}</td>
                                                        <td class="text-xs-left">{{ props.item.status }}</td>
                                                        <td class="justify-center">
                                                            <v-icon small>edit</v-icon>
                                                        </td>
                                                    </template> 

                                                    <template v-slot:no-data>
                                                        <v-alert :value="true" color="grey">
                                                            No Email Available
                                                        </v-alert>
                                                    </template>
                                                </v-data-table>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-flex>
                            </v-layout>

                            <v-layout v-if="item=='Domain'" row wrap> 
                                <v-flex xs6>
                                    <v-container fluid grid-list-md>
                                        <v-layout>
                                            <v-flex xs12>
                                                <v-text-field v-model="domain" label="Domain" required></v-text-field>
                                                <v-spacer></v-spacer>
                                                <v-flex xs12 right>
                                                    <v-btn dark color="blue accent-4" @click="saveDomain()">submit</v-btn>
                                                    <v-btn dark color="red accent-4" @click="clearDomain()">clear</v-btn>
                                                </v-flex>
                                                <br><br>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-flex>

                                <v-flex xs6>
                                    <v-container fluid grid-list-md>
                                        <v-layout>
                                            <v-flex xs12>
                                                <v-data-table :headers="domainHeader" :items="domains" item-key="Id" class="elevation-1">
                                                    <template v-slot:items="props">
                                                        <td>{{ props.item.domain }}</td>
                                                        <td class="text-xs-left">{{ props.item.status }}</td>
                                                        <td class="justify-center">
                                                            <v-icon small>edit</v-icon>
                                                        </td>
                                                    </template> 

                                                    <template v-slot:no-data>
                                                        <v-alert :value="true" color="grey">
                                                            No Domain Available
                                                        </v-alert>
                                                    </template>
                                                </v-data-table>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-flex>
                            </v-layout>

                            <v-layout v-if="item=='Roles'" row wrap> 
                                <v-flex xs6>
                                    <v-container fluid grid-list-md>
                                        <v-layout>
                                            <v-flex xs12>
                                                <v-text-field v-model="role" label="Role" required></v-text-field>
                                                <v-select v-model="level" label="Level" :items="levels" required></v-select>
                                                <v-spacer></v-spacer>
                                                <v-flex xs12 right>
                                                    <v-btn dark color="blue accent-4" @click="saveRole()">submit</v-btn>
                                                    <v-btn dark color="red accent-4" @click="clearRole()">clear</v-btn>
                                                </v-flex>
                                                <br><br>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-flex>

                                <v-flex xs6>
                                    <v-container fluid grid-list-md>
                                        <v-layout>
                                            <v-flex xs12>
                                                <v-data-table :headers="roleheader" :items="roles" item-key="Id" class="elevation-1">
                                                    <template v-slot:items="props">
                                                        <td>{{ props.item.role }}</td>
                                                        <td class="text-xs-left">{{ props.item.level }}</td>
                                                        <td class="text-xs-left">{{ props.item.status }}</td>
                                                        <td class="justify-center">
                                                            <v-icon small>edit</v-icon>
                                                        </td>
                                                    </template> 

                                                    <template v-slot:no-data>
                                                        <v-alert :value="true" color="grey">
                                                            No Roles Available
                                                        </v-alert>
                                                    </template>
                                                </v-data-table>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-flex>
                            </v-layout>

                            <v-layout v-if="item=='Service Category'" row wrap> 
                                <v-flex xs6>
                                    <v-container fluid grid-list-md>
                                        <v-layout>
                                            <v-flex xs12>
                                                <v-text-field v-model="category" label="Category" required></v-text-field>
                                                <v-spacer></v-spacer>
                                                <v-flex xs12 right>
                                                    <v-btn dark color="blue accent-4" @click="saveCategory()">submit</v-btn>
                                                    <v-btn dark color="red accent-4" @click="clearCategory()">clear</v-btn>
                                                </v-flex>
                                                <br><br>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-flex>

                                <v-flex xs6>
                                    <v-container fluid grid-list-md>
                                        <v-layout>
                                            <v-flex xs12>
                                                <v-data-table :headers="categoryHeader" :items="categories" item-key="Id" class="elevation-1">
                                                    <template v-slot:items="props">
                                                        <td>{{ props.item.category }}</td>
                                                        <td class="text-xs-left">{{ props.item.status }}</td>
                                                        <td class="justify-center">
                                                            <v-icon small>edit</v-icon>
                                                        </td>
                                                    </template> 

                                                    <template v-slot:no-data>
                                                        <v-alert :value="true" color="grey">
                                                            No Roles Available
                                                        </v-alert>
                                                    </template>
                                                </v-data-table>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-flex>
                            </v-layout>

                            <v-layout v-if="item=='MC Classification'">
                                <v-flex xs6>
                                    <v-container fluid grid-list-md>
                                        <v-layout>
                                            <v-flex xs12>
                                                <v-text-field v-model="classification" label="MC Classification" required></v-text-field>
                                                <v-spacer></v-spacer>
                                                <v-flex xs12 right>
                                                    <v-btn dark color="blue accent-4" @click="saveClassification()">submit</v-btn>
                                                    <v-btn dark color="red accent-4" @click="clearClassification()">clear</v-btn>
                                                </v-flex>
                                                <br><br>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-flex>

                                <v-flex xs6>
                                    <v-container fluid grid-list-md>
                                        <v-layout>
                                            <v-flex xs12>
                                                <v-data-table :headers="classificationHeader" :items="classifications" item-key="Id" class="elevation-1">
                                                    <template v-slot:items="props">
                                                        <td>{{ props.item.classification }}</td>
                                                        <td class="justify-center">
                                                            <v-icon small>edit</v-icon>
                                                        </td>
                                                    </template> 

                                                    <template v-slot:no-data>
                                                        <v-alert :value="true" color="grey">
                                                            No Classification Available
                                                        </v-alert>
                                                    </template>
                                                </v-data-table>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-flex>
                            </v-layout> 

                            <v-layout v-if="item=='Event'">
                                 <v-flex xs6>
                                    <v-container fluid grid-list-md>
                                        <v-layout>
                                            <v-flex xs12>
                                                <v-select v-model="eventType" :items="items" label="Type" required></v-select>
                                                <v-text-field v-model="event" label="Event" required></v-text-field>

                                                <v-spacer></v-spacer>
                                                <v-flex xs12 right>
                                                    <v-btn dark color="blue accent-4" @click="submit">submit</v-btn>
                                                    <v-btn dark color="red accent-4" @click="clear">clear</v-btn>
                                                </v-flex>
                                                <br><br>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-flex>

                                <v-flex xs6>
                                    <v-container fluid grid-list-md>
                                        <v-layout>
                                            <v-flex xs12>
                                                <v-data-table :headers="eventHeader" :items="events" item-key="Id" class="elevation-1">

                                                </v-data-table>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-flex>
                            </v-layout>

                            <v-layout v-if="item=='Dealer'" row wrap> 
                                <v-flex xs6>
                                    <v-container fluid grid-list-md>
                                        <v-layout>
                                            <v-flex xs12>
                                                <v-text-field v-model="dealer" label="Dealer" required></v-text-field>
                                                <v-spacer></v-spacer>
                                                <v-flex xs12 right>
                                                    <v-btn dark color="blue accent-4" @click="saveDealer()">submit</v-btn>
                                                    <v-btn dark color="red accent-4" @click="clearDealer()">clear</v-btn>
                                                </v-flex>
                                                <br><br>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-flex>

                                <v-flex xs6>
                                    <v-container fluid grid-list-md>
                                        <v-layout>
                                            <v-flex xs12>
                                                <v-data-table :headers="dealerHeader" :items="dealers" item-key="Id" class="elevation-1">
                                                    <template v-slot:items="props">
                                                        <td>{{ props.item.dealer }}</td>
                                                        <td class="justify-center">
                                                            <v-icon small>edit</v-icon>
                                                        </td>
                                                    </template> 

                                                    <template v-slot:no-data>
                                                        <v-alert :value="true" color="grey">
                                                            No Dealers Available
                                                        </v-alert>
                                                    </template>
                                                </v-data-table>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-flex>
                            </v-layout>

                            <v-layout v-if="item=='Brands'" row wrap> 
                                <v-flex xs6>
                                    <v-container fluid grid-list-md>
                                        <v-layout>
                                            <v-flex xs12>
                                                <v-text-field v-model="brand" label="Brand" required></v-text-field>
                                                <v-spacer></v-spacer>
                                                <v-flex xs12 right>
                                                    <v-btn dark color="blue accent-4" @click="saveBrand()">submit</v-btn>
                                                    <v-btn dark color="red accent-4" @click="clearBrand()">clear</v-btn>
                                                </v-flex>
                                                <br><br>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-flex>

                                <v-flex xs6>
                                    <v-container fluid grid-list-md>
                                        <v-layout>
                                            <v-flex xs12>
                                                <v-data-table :headers="dealerHeader" :items="brands" item-key="Id" class="elevation-1">
                                                    <template v-slot:items="props">
                                                        <td>{{ props.item.brand }}</td>
                                                        <td class="justify-center">
                                                            <v-icon small>edit</v-icon>
                                                        </td>
                                                    </template> 

                                                    <template v-slot:no-data>
                                                        <v-alert :value="true" color="grey">
                                                            No Brands Available
                                                        </v-alert>
                                                    </template>
                                                </v-data-table>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-flex>
                            </v-layout>

                            <v-layout v-if="item=='Buffer Time'">
                                <v-flex xs12>
                                    <v-card>
                                        <v-container>
                                            <v-text-field v-model="bufferTime" label="Buffer Time (minutes)" required></v-text-field>
                                                <v-spacer></v-spacer>
                                            <v-flex xs12 right>
                                                <v-btn dark color="blue accent-4" @click="saveBufferTime()">submit</v-btn>
                                                <v-btn dark color="red accent-4" @click="clear">cancel</v-btn>
                                            </v-flex><br><br>
                                        </v-container>
                                    </v-card>
                                </v-flex>
                            </v-layout>     

                            <v-layout v-if="item=='API Credentials'">
                                <v-flex xs12>
                                    <v-card>
                                        <v-card-text>{{ item  }}</v-card-text>
                                    </v-card>
                                </v-flex>
                            </v-layout> 

                            <v-layout v-if="item=='Cancellation'">
                                <v-flex xs6>
                                    <v-container fluid grid-list-md>
                                        <v-layout>
                                            <v-flex xs12>
                                                <v-text-field v-model="reasonForCancellation" label="Reason" required></v-text-field>
                                                <v-spacer></v-spacer>
                                                <v-flex xs12 right>
                                                    <v-btn dark color="blue accent-4" @click="saveCancellation()">submit</v-btn>
                                                    <v-btn dark color="red accent-4" @click="clearCancellation()">clear</v-btn>
                                                </v-flex>
                                                <br><br>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-flex>

                                <v-flex xs6>
                                    <v-container fluid grid-list-md>
                                        <v-layout>
                                            <v-flex xs12>
                                                <v-data-table :headers="cancelHeader" :items="cancellations" item-key="Id" class="elevation-1">
                                                    <template v-slot:items="props">
                                                        <td>{{ props.item.reason }}</td>
                                                        <td class="justify-center">
                                                            <v-icon small>edit</v-icon>
                                                        </td>
                                                    </template> 

                                                    <template v-slot:no-data>
                                                        <v-alert :value="true" color="grey">
                                                            No Reason Available
                                                        </v-alert>
                                                    </template>
                                                </v-data-table>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-flex>
                            </v-layout> 

                            <v-layout v-if="item=='Rejection'">
                                <v-flex xs6>
                                    <v-container fluid grid-list-md>
                                        <v-layout>
                                            <v-flex xs12>
                                                <v-text-field v-model="reasonForRejection" label="Reason" required></v-text-field>
                                                <v-spacer></v-spacer>
                                                <v-flex xs12 right>
                                                    <v-btn dark color="blue accent-4" @click="saveRejection()">submit</v-btn>
                                                    <v-btn dark color="red accent-4" @click="clearRejection()">clear</v-btn>
                                                </v-flex>
                                                <br><br>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-flex>

                                <v-flex xs6>
                                    <v-container fluid grid-list-md>
                                        <v-layout>
                                            <v-flex xs12>
                                                <v-data-table :headers="rejectHeader" :items="rejections" item-key="Id" class="elevation-1">
                                                    <template v-slot:items="props">
                                                        <td>{{ props.item.reason }}</td>
                                                        <td class="justify-center">
                                                            <v-icon small>edit</v-icon>
                                                        </td>
                                                    </template> 

                                                    <template v-slot:no-data>
                                                        <v-alert :value="true" color="grey">
                                                            No Reason Available
                                                        </v-alert>
                                                    </template>
                                                </v-data-table>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-flex>
                            </v-layout>

                            <v-layout v-if="item=='Flat Rate'">
                                <v-flex xs6>
                                    <v-container fluid grid-list-md>
                                        <v-layout>
                                            <v-flex xs12>
                                                <v-text-field v-model="flatRate" label="Flat Rate(minutes)" required></v-text-field>
                                                <v-spacer></v-spacer>
                                                <v-flex xs12 right>
                                                    <v-btn dark color="blue accent-4" @click="saveFlatRate()">submit</v-btn>
                                                    <v-btn dark color="red accent-4" @click="clearFlatRate()">clear</v-btn>
                                                </v-flex>
                                                <br><br>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-flex>

                                <v-flex xs6>
                                    <v-container fluid grid-list-md>
                                        <v-layout>
                                            <v-flex xs12>
                                                <v-data-table :headers="flatRateHeader" :items="flatRates" item-key="Id" class="elevation-1">
                                                    <template v-slot:items="props">
                                                        <td>{{ props.item.time }}</td>
                                                        <td class="justify-center">
                                                            <v-icon small>edit</v-icon>
                                                        </td>
                                                    </template> 

                                                    <template v-slot:no-data>
                                                        <v-alert :value="true" color="grey">
                                                            No flat rate Available
                                                        </v-alert>
                                                    </template>
                                                </v-data-table>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-flex>
                            </v-layout> 

                            <v-layout v-if="item=='Schedule'">
                                <v-flex xs6>
                                    <v-container fluid grid-list-md>
                                        <v-layout>
                                            <v-flex xs12>
                                                <v-text-field v-model="schedule" label="Schedule" required></v-text-field>
                                                <v-spacer></v-spacer>
                                                <v-flex xs12 right>
                                                    <v-btn dark color="blue accent-4" @click="saveSchedule()">submit</v-btn>
                                                    <v-btn dark color="red accent-4" @click="clearSchedule()">clear</v-btn>
                                                </v-flex>
                                                <br><br>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-flex>

                                <v-flex xs6>
                                    <v-container fluid grid-list-md>
                                        <v-layout>
                                            <v-flex xs12>
                                                <v-data-table :headers="scheduleHeader" :items="schedules" item-key="Id" class="elevation-1">
                                                    <template v-slot:items="props">
                                                        <td>{{ props.item }}</td>
                                                        <td class="justify-center">
                                                            <v-icon small>edit</v-icon>
                                                        </td>
                                                    </template> 

                                                    <template v-slot:no-data>
                                                        <v-alert :value="true" color="grey">
                                                            No Schedule Available
                                                        </v-alert>
                                                    </template>
                                                </v-data-table>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-flex>
                            </v-layout>

                            </div>    
                        </v-tab-item>
                    </v-tabs>
                    </v-flex>
                </v-layout>
            </v-container>
            <v-layout>
                <v-dialog v-model="showProgress" persistent width="300">
                    <v-card  color="primary">
                        <v-card-text class="subheading white--text">{{progressMessage}}
                            <v-layout row justify-center>
                            <v-progress-linear :indeterminate="true" :size="70" :width="5" color="white"></v-progress-linear>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-dialog>

                <v-snackbar v-model="snackbar" bottom right :color="snackbarColor" :timeout=3000>
                        {{snackbarMessage}}
                    <v-btn dark small flat @click="showSnackBar = false">Close</v-btn>
                </v-snackbar>
            </v-layout>
        </v-app>
    </div>
</template>

<script>
import firebase from "firebase";
import firebaseui from "firebaseui";
import "../../node_modules/firebaseui/dist/firebaseui.css";
import { config } from "../firebaseConfig";
import router from '../router';
import { db } from '../main.js'
import { mapGetters, mapActions } from "vuex";
import store from '../stores'
import moment from 'moment'
import _ from 'lodash';
export default {
    data() {
        return {
            active: null,
            items: [
                "HO-Users",
                "Domain",
                "Roles",
                "Service Category",
                "MC Classification", 
                "Event", 
                "Cancellation",
                "Rejection",
                "Dealer",
                "Brands",
                "API Credentials",
                "Buffer Time",
                "Flat Rate",
                "Schedule"
            ],
            type: "",
            url: "",
            linkHeader:  [
                { text: "Type",  align: "left", value: "type"},
                { text: "URL",align: "left", value: "url" },
                { text: "Action", align: "left" }
            ],

            email: "",
            emails: [],
            emailHeader:  [
                { text: "Email", align: "left", value: "email"},
                { text: "Status", align: "left", value: "status" },
                { text: "Action", align: "left", value: "name" }
            ],

            domain: "",
            domains: [],
            domainHeader:  [
                { text: "Domain", align: "left", value: "domain"},
                { text: "Status", align: "left", value: "status" },
                { text: "Action", align: "left", value: "name" }
            ],

            category: "",
            categories: [],
            categoryHeader:  [
                { text: "Category", align: "left", value: "category"},
                { text: "Status", align: "left", value: "status" },
                { text: "Action", align: "left", value: "name" }
            ],

            role: "",
            roles: [],
            levels: ["1","2"],
            level: "",
            roleheader:  [
                { text: "Role", align: "left", value: "role"},
                { text: "Level", align: "left", value: "level" },
                { text: "Status", align: "left", value: "status" },
                { text: "Action", align: "left", value: "name" }
            ],

            event: "",
            events: [],
            eventType: "",
            eventHeader:  [
                { text: "Type",  align: "left", value: "type"},
                { text: "Event" ,align: "left", value:"event" },
            ],
            showProgress: false,
            progressMessage: "",
            snackbar: false,
            snackbarMessage: "",
            snackbarColor: "",
            bufferTime: 0,
            dealer: "",
            dealers: [],
            dealerHeader: [
                { text: "Dealer",  align: "left", value: "dealer"},
                { text: "Action" ,align: "left" },
            ],
            brand: "",
            brands: [],
            brandHeader: [
                { text: "Brand",  align: "left", value: "brand"},
                { text: "Action", align: "left" },
            ],
            reasonForCancellation: "",
            cancellations: [],
            cancelHeader: [
                { text: "Reason",  align: "left", value: "reason"},
                { text: "Action", align: "left" },
            ],
            reasonForRejection: "",
            rejections: [],
            rejectHeader: [
                { text: "Reason",  align: "left", value: "reason"},
                { text: "Action", align: "left" },
            ],
            classification: "",
            classifications: [],
            classificationHeader: [
                { text: "Classification",  align: "left", value: "classification"},
                { text: "Action", align: "left" },
            ],
            flatRate: "",
            flatRates: [],
            flatRateHeader: [
                { text: "Time Rate (minutes)",  align: "left", value: "time"},
                { text: "Action", align: "left" },
            ],
            schedule: "",
            schedules: [],
            scheduleHeader: [
                { text: "Time Rate (minutes)",  align: "left", value: "time"},
                { text: "Action", align: "left" },
            ],
        }
    },

    methods: {
        next () {
            const active = parseInt(this.active)
            this.active = (active < 2 ? active + 1 : 0)
        },

        clear(){
            let self = this

        },

        submit() {
            let self = this
        },

        saveUser() {
            let self = this
            self.showProgress = true
            self.progressMessage = "Saving..."
            db.collection("HO-Users"+self.$stage).doc(self.email)
            .set({
                email: self.email,
                status: "active"
            }).then(function() {
                self.clearUser()
                self.showProgress = false
                self.snackbarMessage = "Saved"
                self.snackbarColor = "success"
                self.snackbar = true
                self.fetchEmails()
            }).catch(function(error) {
                self.clearUser()
                self.showProgress = false
                console.log(error)
                self.snackbarMessage = "Error saving document"
                self.snackbarColor = "error"
                self.snackbar = true
            })
        },

        clearUser() {
            let self = this
            self.email = ""
        },

        async fetchEmails(){
            let self = this
            self.emails = []
            self.progressMessage = "Loading..."
            self.showProgress = true
            await db.collection("HO-Users"+self.$stage)
            .get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc) {
                    self.emails.push(doc.data())
                }) 
            }).then(function(){
                self.showProgress = false
            }).catch(function(error) {
                console.log(error)
                self.snackbarMessage = "Error getting document"
                self.snackbarColor = "error"
                self.snackbar = true
            })
        },

        saveDomain() {
            let self = this
            self.progressMessage = "Saving..."
            self.showProgress = true

            db.collection("Settings").doc("Domain")
            .collection("Items").doc(self.domain).set({
                domain: self.domain,
                status: "active"
            }).then(function(){
                self.domain = ""
                self.showProgress = false
                self.snackbarMessage = "Saved"
                self.snackbarColor = "success"
                self.snackbar = true
                self.fetchDomain()
            }).catch(function(error) {
                console.log(error)
                self.showProgress = false
                self.snackbarMessage = "Error saving document"
                self.snackbarColor = "error"
                self.snackbar = true
            })
        },

        clearDomain(){
            let self = this
            self.domain = ""
        },

        async fetchDomain(){
            let self = this
            self.domains = []
            self.progressMessage = "Loading..."
            self.showProgress = true
            db.collection("Settings").doc("Domain")
            .collection("Items").get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc) {
                    if(doc.exists) {
                        self.domains.push(doc.data())
                        self.showProgress = false
                    } else {
                        self.showProgress = false
                    }
                }) 
            }).catch(function(error) {
                console.log(error)
                self.snackbarMessage = "Error getting document"
                self.snackbarColor = "error"
                self.snackbar = true
            })
        },

        saveCategory() {
            let self = this
            self.progressMessage = "Saving..."
            self.showProgress = true

            db.collection("Settings").doc("Categories")
            .collection("Items").doc(self.category).set({
                category: self.category,
                status: "active"
            }).then(function(){
                self.category = ""
                self.showProgress = false
                self.snackbarMessage = "Saved"
                self.snackbarColor = "success"
                self.snackbar = true
                self.fetchCategories()
            }).catch(function(error) {
                console.log(error)
                self.showProgress = false
                self.snackbarMessage = "Error saving document"
                self.snackbarColor = "error"
                self.snackbar = true
            })
        },

        clearCategory(){
            let self = this
            self.category = ""
        },

        async fetchCategories(){
            let self = this
            self.categories = []
            self.progressMessage = "Loading..."
            self.showProgress = true
            db.collection("Settings").doc("Categories")
            .collection("Items").get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc) {
                    if(doc.exists) {
                        self.categories.push(doc.data())
                        self.showProgress = false
                    } else {
                        self.showProgress = false
                    }
                }) 
            }).catch(function(error) {
                console.log(error)
                self.snackbarMessage = "Error getting document"
                self.snackbarColor = "error"
                self.snackbar = true
            })
        },

        saveSchedule() {
            let self = this
            self.progressMessage = "Saving..."
            self.showProgress = true

            db.collection("Settings").doc("Schedule")
            .collection("Items").doc(self.schedule).set({
                time: self.schedule
            }).then(function(){
                self.schedule = ""
                self.showProgress = false
                self.snackbarMessage = "Saved"
                self.snackbarColor = "success"
                self.snackbar = true
                self.fetchSchedule()
            }).catch(function(error) {
                console.log(error)
                self.showProgress = false
                self.snackbarMessage = "Error saving document"
                self.snackbarColor = "error"
                self.snackbar = true
            })
        },

        clearSchedule(){
            let self = this
            self.schedule = ""
        },

        async fetchSchedule(){
            let self = this
            let count = 0
            self.schedules = []
            self.progressMessage = "Loading..."
            self.showProgress = true
            db.collection("Settings").doc("Schedule")
            .collection("Items").get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc) {
                    count ++
                    if(doc.exists) {
                        self.schedules.push(doc.data().time)
                        self.showProgress = false
                    } else {
                        self.showProgress = false
                    }

                    if (count === querySnapshot.docs.length) {
                        self.schedules.sort(function (timeA, timeB) {
                            return new Date('1970/01/01 ' + timeA) - new Date('1970/01/01 ' + timeB);
                        })
                    }
                }) 
            }).catch(function(error) {
                console.log(error)
                self.snackbarMessage = "Error getting document"
                self.snackbarColor = "error"
                self.snackbar = true
            })
        },

        saveFlatRate() {
            let self = this
            self.progressMessage = "Saving..."
            self.showProgress = true

            db.collection("Settings").doc("FlatRate")
            .collection("Items").doc(self.flatRate).set({
                time: Number(self.flatRate)
            }).then(function(){
                self.flatRate = ""
                self.showProgress = false
                self.snackbarMessage = "Saved"
                self.snackbarColor = "success"
                self.snackbar = true
                self.fetchFlatRate()
            }).catch(function(error) {
                console.log(error)
                self.showProgress = false
                self.snackbarMessage = "Error saving document"
                self.snackbarColor = "error"
                self.snackbar = true
            })
        },

        clearFlatRate(){
            let self = this
            self.flatRate = ""
        },

        async fetchFlatRate(){
            let self = this
            let count = 0
            self.flatRates = []
            self.progressMessage = "Loading..."
            self.showProgress = true
            db.collection("Settings").doc("FlatRate")
            .collection("Items").get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc) {
                    count ++
                    if(doc.exists) {
                        self.flatRates.push(doc.data())
                        self.showProgress = false
                    } else {
                        self.showProgress = false
                    }

                    if (count === querySnapshot.docs.length) {
                        self.flatRates.sort(function(a, b){return a-b})
                    }
                }) 
            }).catch(function(error) {
                console.log(error)
                self.snackbarMessage = "Error getting document"
                self.snackbarColor = "error"
                self.snackbar = true
            })
        },

        saveClassification() {
            let self = this
            self.progressMessage = "Saving..."
            self.showProgress = true

            db.collection("Settings").doc("Classification")
            .collection("Items").doc(self.classification).set({
                classification: self.classification
            }).then(function(){
                self.classification = ""
                self.showProgress = false
                self.snackbarMessage = "Saved"
                self.snackbarColor = "success"
                self.snackbar = true
                self.fetchClassification()
            }).catch(function(error) {
                console.log(error)
                self.showProgress = false
                self.snackbarMessage = "Error saving document"
                self.snackbarColor = "error"
                self.snackbar = true
            })
        },

        clearClassification(){
            let self = this
            self.classification = ""
        },

        async fetchClassification(){
            let self = this
            self.classifications = []
            self.progressMessage = "Loading..."
            self.showProgress = true
            db.collection("Settings").doc("Classification")
            .collection("Items").get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc) {
                    if(doc.exists) {
                        self.classifications.push(doc.data())
                        self.showProgress = false
                    } else {
                        self.showProgress = false
                    }
                }) 
            }).catch(function(error) {
                console.log(error)
                self.snackbarMessage = "Error getting document"
                self.snackbarColor = "error"
                self.snackbar = true
            })
        },

        saveRejection() {
            let self = this
            self.progressMessage = "Saving..."
            self.showProgress = true

            db.collection("Settings").doc("Rejection")
            .collection("Items").doc(self.reasonForRejection).set({
                reason: self.reasonForRejection
            }).then(function(){
                self.reasonForRejection = ""
                self.showProgress = false
                self.snackbarMessage = "Saved"
                self.snackbarColor = "success"
                self.snackbar = true
                self.fetchRejection()
            }).catch(function(error) {
                console.log(error)
                self.showProgress = false
                self.snackbarMessage = "Error saving document"
                self.snackbarColor = "error"
                self.snackbar = true
            })
        },

        clearRejection(){
            let self = this
            self.reasonForRejection = ""
        },

        async fetchRejection(){
            let self = this
            self.rejections = []
            self.progressMessage = "Loading..."
            self.showProgress = true
            db.collection("Settings").doc("Rejection")
            .collection("Items").get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc) {
                    if(doc.exists) {
                        self.rejections.push(doc.data())
                        self.showProgress = false
                    } else {
                        self.showProgress = false
                    }
                }) 
            }).catch(function(error) {
                console.log(error)
                self.snackbarMessage = "Error getting document"
                self.snackbarColor = "error"
                self.snackbar = true
            })
        },

        saveCancellation() {
            let self = this
            self.progressMessage = "Saving..."
            self.showProgress = true

            db.collection("Settings").doc("Cancellation")
            .collection("Items").doc(self.reasonForCancellation).set({
                reason: self.reasonForCancellation
            }).then(function(){
                self.reasonForCancellation = ""
                self.showProgress = false
                self.snackbarMessage = "Saved"
                self.snackbarColor = "success"
                self.snackbar = true
                self.fetchCancellation()
            }).catch(function(error) {
                console.log(error)
                self.showProgress = false
                self.snackbarMessage = "Error saving document"
                self.snackbarColor = "error"
                self.snackbar = true
            })
        },

        clearCancellation(){
            let self = this
            self.reasonForCancellation = ""
        },

        async fetchCancellation(){
            let self = this
            self.cancellations = []
            self.progressMessage = "Loading..."
            self.showProgress = true
            db.collection("Settings").doc("Cancellation")
            .collection("Items").get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc) {
                    if(doc.exists) {
                        self.cancellations.push(doc.data())
                        self.showProgress = false
                    } else {
                        self.showProgress = false
                    }
                }) 
            }).catch(function(error) {
                console.log(error)
                self.snackbarMessage = "Error getting document"
                self.snackbarColor = "error"
                self.snackbar = true
            })
        },

        saveBrand(){
            let self = this
            self.progressMessage = "Saving..."
            self.showProgress = true

            db.collection("Settings").doc("Brands")
            .collection("Items").doc(self.brand).set({
                brand: self.brand
            }).then(function(){
                self.brand = ""
                self.showProgress = false
                self.snackbarMessage = "Saved"
                self.snackbarColor = "success"
                self.snackbar = true
                self.fetchBrand()
            }).catch(function(error) {
                console.log(error)
                self.showProgress = false
                self.snackbarMessage = "Error saving document"
                self.snackbarColor = "error"
                self.snackbar = true
            })
        },

        clearBrand() {
            let self = this
            self.brand = ""
        },

        async fetchBrand(){
            let self = this
            self.brands = []
            self.progressMessage = "Loading..."
            self.showProgress = true
            db.collection("Settings").doc("Brands")
            .collection("Items").get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc) {
                    if(doc.exists) {
                        self.brands.push(doc.data())
                        self.showProgress = false
                    } else {
                        self.showProgress = false
                    }
                }) 
            }).catch(function(error) {
                console.log(error)
                self.snackbarMessage = "Error getting document"
                self.snackbarColor = "error"
                self.snackbar = true
            })
        },

        saveDealer(){
            let self = this
            self.progressMessage = "Saving..."
            self.showProgress = true

            db.collection("Settings").doc("Dealers")
            .collection("Items").doc(self.dealer).set({
                dealer: self.dealer
            }).then(function(){
                self.dealer = ""
                self.showProgress = false
                self.snackbarMessage = "Saved"
                self.snackbarColor = "success"
                self.snackbar = true
                self.fetchDealer()
            }).catch(function(error) {
                console.log(error)
                self.showProgress = false
                self.snackbarMessage = "Error saving document"
                self.snackbarColor = "error"
                self.snackbar = true
            })
        },

        clearDealer() {
            let self = this
            self.dealer = ""
        },

        async fetchDealer(){
            let self = this
            self.dealers = []
            self.progressMessage = "Loading..."
            self.showProgress = true
            db.collection("Settings").doc("Dealers")
            .collection("Items").get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc) {
                    if(doc.exists) {
                        self.dealers.push(doc.data())
                        self.showProgress = false
                    } else {
                        self.showProgress = false
                    }
                }) 
            }).catch(function(error) {
                console.log(error)
                self.snackbarMessage = "Error getting document"
                self.snackbarColor = "error"
                self.snackbar = true
            })
        },

        async fetchBufferTime() {
            let self = this
            self.progressMessage = "Loading..."
            self.showProgress = true
            db.collection("Settings").doc("BufferTime")
            .collection("Items").get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc) {
                    if(doc.exists) {
                        self.bufferTime = doc.data().time
                        self.showProgress = false
                    } else {
                        self.bufferTime = 0
                        self.showProgress = false
                    }
                }) 
            }).catch(function(error) {
                console.log(error)
                self.snackbarMessage = "Error getting document"
                self.snackbarColor = "error"
                self.snackbar = true
            })
        },

        saveBufferTime() {
            let self = this
            self.progressMessage = "Saving..."
            self.showProgress = true

            db.collection("Settings").doc("BufferTime")
            .collection("Items").doc(self.bufferTime).set({
                time: Number(self.bufferTime)
            }).then(function(){
                self.showProgress = false
                self.snackbarMessage = "Saved"
                self.snackbarColor = "success"
                self.snackbar = true
                self.fetchBufferTime()
            }).catch(function(error) {
                console.log(error)
                self.showProgress = false
                self.snackbarMessage = "Error saving document"
                self.snackbarColor = "error"
                self.snackbar = true
            })
        },

        async fetchRoles() {
            let self = this
            self.roles = []
            self.progressMessage = "Loading..."
            self.showProgress = true
            await db.collection("Settings").doc("Roles")
            .collection("Items").get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc) {
                    self.roles.push(doc.data())
                })
            }).then(function(){
                self.showProgress = false
            }).catch(function(error) {
                console.log(error)
                self.showProgress = false
                self.snackbarMessage = "Error fetching roles"
                self.snackbarColor = "error"
                self.snackbar = true
            })
        },

        saveRole() {
            let self = this
            self.showProgress = true
            self.progressMessage = "Saving..."
            db.collection("Settings").doc("Roles")
            .collection("Items").doc(self.role).set({
                role: self.role,
                level: self.level,
                status: "active"
            }).then(function() {
                self.clearRole()
                self.showProgress = false
                self.snackbarMessage = "Saved"
                self.snackbarColor = "success"
                self.snackbar = true
                self.fetchRoles()
            }).catch(function(error) {
                self.clearRole()
                self.showProgress = false
                console.log(error)
                self.snackbarMessage = "Error saving document"
                self.snackbarColor = "error"
                self.snackbar = true
            })
        },

        clearRole() {
            let self = this
            self.role = ""
            self.level = ""
        }
    },

    mounted() {
        let self = this
        self.fetchEmails()
        self.fetchRoles()
        self.fetchBufferTime()
        self.fetchDealer()
        self.fetchBrand()
        self.fetchCancellation()
        self.fetchRejection()
        self.fetchFlatRate()
        self.fetchClassification()
        self.fetchSchedule()
        self.fetchDomain()
        self.fetchCategories()
    },

    computed : {
        ...mapGetters(["user"]),
    },
}
</script>

<style scoped>

</style>